/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Modal, ModalFooter } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import { getTranslatedItemStatus } from '@folio/inventory/src/constants';

function ConfirmDeleteItemModal({
  onClose,
  open,
  onRemove,
  canDelete,
  itemRecord,
}) {
  const itemHrid = itemRecord.itemHrid ? `- ${itemRecord.itemHrid}` : '';
  const itemStatus = (
    <FormattedMessage
      id={getTranslatedItemStatus(get(itemRecord, 'status.name'))}
      defaultMessage={get(itemRecord, 'status.name')}
    />
  );

  const renderFooter = () => {
    return (
      <ModalFooter>
        {canDelete && (
          <Button
            id="confirm-delete-holding-modal-btn"
            buttonStyle="primary"
            onClick={() => onRemove()}
          >
            <FormattedMessage
              id="ui-plugin-inventory-templates.buttons.deleteItem"
              defaultMessage="Delete item"
            />
          </Button>
        )}
        <Button id="confirm-delete-item-modal-cancel-btn" onClick={onClose}>
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ModalFooter>
    );
  };

  return (
    <Modal
      id="confirm-delete-item-modal"
      open={open}
      onClose={onClose}
      footer={renderFooter()}
      label={
        <Icon icon="trash" size="large">
          <FormattedMessage
            id="ui-plugin-inventory-templates.confirmDeleteItemModal.label"
            values={{
              itemHrid: <strong>{itemHrid}</strong>,
            }}
            defaultMessage="Confirm delete item {itemHrid}"
          />
        </Icon>
      }
    >
      {canDelete ? (
        <FormattedMessage
          id="ui-plugin-inventory-templates.tooltips.deleteItem.msg"
          values={{
            itemHrid: <strong>{itemHrid}</strong>,
          }}
          defaultMessage="Are you sure you want to delete the item {itemHrid}?"
        />
      ) : (
        <FormattedMessage
          id="ui-plugin-inventory-templates.tooltips.notAllowDeleteItem.msg"
          values={{
            itemHrid: <strong>{itemHrid}</strong>,
            itemStatus: <strong>{itemStatus}</strong>,
            br: <br />,
          }}
          defaultMessage="This item record {itemHrid} cannot be deleted, because it's status is {itemStatus}. {br} To be able to continue deletion of this item, you must assign this item status to be available."
        />
      )}
    </Modal>
  );
}

ConfirmDeleteItemModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onRemove: PropTypes.func,
  canDelete: PropTypes.bool,
  itemRecord: PropTypes.object,
};

export default ConfirmDeleteItemModal;
